module.exports = __webpack_public_path__ + "img/framee24.10c8af01.png";